/* POWSTORE Header 2027 – Verhalten (defer, ohne Abhängigkeiten)
   - Header bleibt oben und blendet beim Runterscrollen aus, beim Hochscrollen ein
   - Megamenü: öffnet per Hover (CSS) bzw. Tastatur; Touch-Tablets: erster Tipp öffnet, zweiter folgt dem Link
   - Escape schließt; aria-expanded wird mitgeführt
   - Handymenü als Schublade mit Unterebenen, Fokusfalle, Scroll-Sperre */
(function () {
  if (customElements.get('pow-header')) return;

  class PowHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.items = Array.from(this.querySelectorAll('[data-pw-menu]'));
      this.lastY = window.scrollY;
      if (this.dataset.sticky === 'true') {
        this.section.classList.add('is-sticky');
        window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      }
      this.items.forEach((li) => {
        const a = li.querySelector(':scope > .pw-nav__link');
        li.addEventListener('mouseenter', () => this.setOpen(li, true));
        li.addEventListener('mouseleave', () => this.setOpen(li, false));
        li.addEventListener('focusin', () => this.setOpen(li, true));
        li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) this.setOpen(li, false); });
        a.addEventListener('pointerdown', (e) => { this.lastPointer = e.pointerType; });
        a.addEventListener('click', (e) => {
          if (this.lastPointer === 'touch' && !li.classList.contains('is-open')) {
            e.preventDefault();
            this.items.forEach((o) => o !== li && this.setOpen(o, false));
            this.setOpen(li, true);
          }
        });
        a.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') { e.preventDefault(); const f = li.querySelector('.pw-mega a, .pw-drop a'); f && f.focus(); }
        });
      });
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const open = this.items.find((li) => li.classList.contains('is-open'));
        if (open) { this.setOpen(open, false, true); open.querySelector('.pw-nav__link').focus(); }
      });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.items.forEach((li) => this.setOpen(li, false)); });
    }
    setOpen(li, open, force) {
      const a = li.querySelector(':scope > .pw-nav__link');
      li.classList.toggle('is-open', open);
      li.classList.toggle('is-closed', !!force && !open);
      if (!open && !force) li.classList.remove('is-closed');
      if (force && !open) setTimeout(() => li.classList.remove('is-closed'), 300);
      a && a.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const h = this.offsetHeight;
        const anyOpen = this.items.some((li) => li.classList.contains('is-open')) || this.querySelector('details[open]');
        this.section.classList.toggle('is-scrolled', y > 2);
        if (!anyOpen) {
          if (y > this.lastY && y > h * 2) this.section.classList.add('is-hidden');
          else if (y < this.lastY - 4 || y <= h) this.section.classList.remove('is-hidden');
        }
        this.lastY = y;
        this.ticking = false;
      });
    }
  }
  customElements.define('pow-header', PowHeader);

  class PowDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.pw-drawer__panel');
      this.root = this.querySelector('[data-pw-view="root"]');
      this.openers = Array.from(document.querySelectorAll('[data-pw-drawer-open]'));
      this.openers.forEach((b) => b.addEventListener('click', () => this.open(b)));
      this.querySelectorAll('[data-pw-drawer-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.querySelectorAll('[data-pw-sub]').forEach((b) => b.addEventListener('click', () => this.showSub(b)));
      this.querySelectorAll('[data-pw-back]').forEach((b) => b.addEventListener('click', () => this.back()));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { this.current ? this.back() : this.close(); }
        if (e.key === 'Tab') this.trap(e);
      });
      window.matchMedia('(min-width:1100px)').addEventListener('change', (m) => { if (m.matches) this.close(); });
    }
    open(trigger) {
      this.trigger = trigger;
      this.hidden = false;
      document.documentElement.classList.add('pw-lock');
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
      this.openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      setTimeout(() => this.panel.focus(), 50);
    }
    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('pw-lock');
      this.openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      setTimeout(() => { this.hidden = true; this.resetViews(); }, 300);
      this.trigger && this.trigger.focus();
    }
    showSub(btn) {
      const view = document.getElementById(btn.getAttribute('data-pw-sub'));
      if (!view) return;
      this.currentBtn = btn;
      view.hidden = false;
      requestAnimationFrame(() => { view.classList.add('is-active'); this.root.classList.add('is-behind'); });
      btn.setAttribute('aria-expanded', 'true');
      this.current = view;
      setTimeout(() => { const b = view.querySelector('[data-pw-back]'); b && b.focus(); }, 260);
    }
    back() {
      const view = this.current;
      if (!view) return;
      view.classList.remove('is-active');
      this.root.classList.remove('is-behind');
      this.current = null;
      setTimeout(() => { view.hidden = true; }, 260);
      if (this.currentBtn) { this.currentBtn.setAttribute('aria-expanded', 'false'); this.currentBtn.focus(); }
    }
    resetViews() {
      this.querySelectorAll('.pw-drawer__view--sub').forEach((v) => { v.classList.remove('is-active'); v.hidden = true; });
      this.root.classList.remove('is-behind');
      this.current = null;
    }
    trap(e) {
      const scope = this.current || this.root;
      const f = Array.from(this.querySelectorAll('.pw-drawer__head a, .pw-drawer__head button')).concat(
        Array.from(scope.querySelectorAll('a[href], button, summary'))
      ).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  customElements.define('pow-drawer', PowDrawer);
})();
